// extracted by mini-css-extract-plugin
export default {"auth-callback":"AuthCallback_auth-callback__9D3wl"};